import * as React from 'react';

export type StepStatus = 'pending' | 'processing' | 'finished' | 'errored';

export enum StepPosition {
  FIRST = 'first',
  INBETWEEN = 'inbetween',
  LAST = 'last'
}

export interface StepTitleRenderFnProps {
  title: React.ReactNode;
  status: StepStatus;
  stepPosition: StepPosition;
  stepNumber: string | number;
  stepIndex: number;
  isCurrentStep: boolean;
  center: boolean;
  vertical: boolean;
}

export type StepTitleRenderFn = (props: StepTitleRenderFnProps) => React.ReactNode;

export interface StepHeadRenderProps {
  stepPosition: StepPosition;
  stepNumber: string | number;
  stepIndex: number;
  isCurrentStep: boolean;
}

export type StepHeadRenderFn = (props: StepHeadRenderProps) => React.ReactNode;

export interface StepsProps {
  currentStepIndex: number;
  status?: StepStatus;
  children: React.ReactNode;
  className?: string;
  vertical?: boolean;
  center?: boolean;
  dot?: boolean;
  getStepNumber?: (index: number) => string | number;
  stepTitle?: StepTitleRenderFn;
  stepHeads?: {[key in StepStatus]?: StepHeadRenderFn};
  customClassName?: {
    connector?: string;
    main?: string;
    title?: string;
    content?: string;
  };
  customStyle?: {
    connector?: React.CSSProperties;
    main?: React.CSSProperties;
    title?: React.CSSProperties;
    content?: React.CSSProperties;
  };
}

export interface StepProps {
  title: React.ReactNode;
  children: React.ReactNode;
}

export interface StepRendererProps
  extends StepProps,
    Pick<StepsProps, 'stepHeads' | 'customClassName' | 'customStyle'> {
  style: React.CSSProperties;
  stepNumber: number | string;
  stepIndex: number;
  stepPosition: StepPosition;
  isCurrentStep: boolean;
  status: StepStatus;
  vertical: boolean;
  center: boolean;
  dot: boolean;
  renderTitle?: StepTitleRenderFn;
}



// WEBPACK FOOTER //
// ./src/components/Steps/types.ts